'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOAPCache = void 0;
const utils_keyvaluecache_1 = require("@apollo/utils.keyvaluecache");
/**
 * SOAP Cache utility
 *
 * SOAP is sent as HTTP POST and its a non-idempotent. Thus it can not be cached
 * at HTTP level.
 *
 * This[1] is draft version of document for response caching for SOAP, but did
 * not found any implementation of it.
 *
 * Thus it make sense to client decide to cache it or not and for much duration.
 *
 * [1]: https://lists.w3.org/Archives/Public/www-ws/2001Aug/att-0000/ResponseCache.html
 */
class SOAPCache {
    /**
     * A constructor
     *
     * @param {Object} keyValueCache a cache object from apollo server en
     */
    constructor(keyValueCache = new utils_keyvaluecache_1.InMemoryLRUCache()) {
        this.keyValueCache = keyValueCache;
    }
    /**
     * Get the cached value from cache by key
     *
     * @param {String} key a cache key
     * @return {Object} a value of the cached object
     *
     */
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const entry = yield this.keyValueCache.get('soapcache:' + key);
            if (entry) {
                return JSON.parse(entry);
            }
            return null;
        });
    }
    /**
     * Put value to be cached with the key
     *
     * @param {String} key a cache key
     * @param {Object} value the value to be cached
     * @param {Integer} ttl the ttl value in seconds
     *
     */
    put(key, value, ttl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (ttl > 0) {
                yield this.keyValueCache.set('soapcache:' + key, JSON.stringify(value), {
                    ttl,
                });
            }
        });
    }
}
exports.SOAPCache = SOAPCache;
